/**
 * Created by rickborst on 28/02/2017.
 */

export {default as Kaltura} from './kaltura';


// WEBPACK FOOTER //
// ./src/js/datasources/index.js